import { Dimension } from '../types/Dimension'

export const getDimensionTree = (dimensionList: Dimension[]): Dimension[] => {
  if (!dimensionList || dimensionList.length === 0) return []

  const sortedDimensions = dimensionList.slice().sort((a, b) => a.order - b.order) // Nopeampi kuin > comparison

  const dimensionMap = new Map<string, Dimension>()
  const childrenMap = new Map<string, Dimension[]>()

  for (const dimension of sortedDimensions) {
    dimensionMap.set(dimension.dimensionId, dimension)

    const parentId = dimension.parentDimensionId
    if (parentId != null) {
      if (!childrenMap.has(parentId)) {
        childrenMap.set(parentId, [])
      }
      childrenMap.get(parentId)!.push(dimension)
    }
  }

  const buildTree = (dimension: Dimension): Dimension => {
    const children = childrenMap.get(dimension.dimensionId) || []
    return children.length > 0 ? { ...dimension, children: children.map(buildTree) } : { ...dimension }
  }

  const roots = sortedDimensions.filter(d => d.parentDimensionId == null || !dimensionMap.has(d.parentDimensionId))

  return roots.map(buildTree)
}
